import { render, staticRenderFns } from "./detailTable.vue?vue&type=template&id=3dd2a876&scoped=true&"
import script from "./detailTable.vue?vue&type=script&lang=js&"
export * from "./detailTable.vue?vue&type=script&lang=js&"
import style0 from "./detailTable.vue?vue&type=style&index=0&id=3dd2a876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd2a876",
  null
  
)

export default component.exports